import { render, staticRenderFns } from "./OnlyWork.vue?vue&type=template&id=7047e2bb&scoped=true&"
import script from "./OnlyWork.vue?vue&type=script&lang=js&"
export * from "./OnlyWork.vue?vue&type=script&lang=js&"
import style0 from "./OnlyWork.vue?vue&type=style&index=0&id=7047e2bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047e2bb",
  null
  
)

export default component.exports